import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({
  title = 'Fastlane ApS - Shipping, Fragt og Spedition i hele verden',
  description = 'Fastlane tilbyder international shipping af gods. Engageret og professionel outsourcing af alle former for transport og spedition.',
  canonicalUrl = '',
  ogImage = 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/logo.png',
  keywords = ''
}) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* OpenGraph */}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
